// A number is digits, with a + in front of it for the international prefix. Anything
// else is dropped as it is typed, the way the mileage field drops non-digits.
const disallowedCharacters = /[^\d+]/g;
// No further format is imposed on the number, only a length. Mirrored by MaxLength on
// the backend DTO.
export const maxPhoneNumberLength = 20;

export function sanitizePhoneNumber(value: string): string {
  return value.replace(disallowedCharacters, '');
}
